import axios from "axios";
import { ReportConfig } from "../../pages/reportConfigs/typings";

const { REACT_APP_REPORTING_API } = process.env;

export const getReportConfigs = async (
  page = 1,
  cancelToken,
  orderBy = "report_type",
  order = "asc",
  results_per_page = 100,
) => {
  const url = `&results_per_page=${results_per_page}&page=${page}&order_by=${orderBy}&order=${order}`;
  const params = new URLSearchParams(url);
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_REPORTING_API}/report_configs?${params.toString()}`,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return {
      data: res.data,
      hasNextPage: res.data?.has_next_page,
      count: res.data?.count,
    };
  } catch (e) {
    throw new Error(e?.response?.data?.details || "Failed to get report configs.");
  }
};

export const deleteReportConfig = async (configId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "delete",
      url: `${REACT_APP_REPORTING_API}/report_configs/${configId}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data.data };
  } catch (e) {
    throw new Error(e?.response?.data?.details || `Failed to delete report config ${configId}.`);
  }
};

export const createReportConfig = async (
  config: Omit<ReportConfig, "_id">,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_REPORTING_API}/report_configs`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        ...config,
      },
    });
    return { data: response.data.data };
  } catch (e) {
    throw new Error(e?.response?.data?.details || "Failed to create a new report config.");
  }
};

export const updateReportConfig = async (
  config: Partial<ReportConfig>,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "put",
      url: `${REACT_APP_REPORTING_API}/report_configs/${config._id}`,
      headers: { Authorization: `Bearer ${token}` },
      data: config,
    });
    return { data: response.data.data };
  } catch (e) {
    throw new Error(e?.response?.data?.details || `Failed to update report config ${config._id}.`);
  }
};
